import { NoteType } from "../../domain/notes.domain";

/**
 * Look up saved is_system instructions from a user's TYPE_ANY Customization object
 * for a given note type. This handles the case where prebuilt template customizations
 * were never migrated to CustomNote.prompt (migration 0204/0206 skipped them).
 */
export function getSavedInstructionsForNoteType(
  customizationList: any[] | undefined,
  noteType: number | null | undefined,
): string {
  if (noteType == null || noteType === NoteType.SOAP || noteType === NoteType.DAP) {
    return "";
  }

  // TYPE_ANY = 2
  const anyTypeCustomization = customizationList?.find((item) => item.customization_type === 2);
  const instructionData = anyTypeCustomization?.customization?.note_type_instructions?.[noteType];

  if (!instructionData) {
    return "";
  }

  if (typeof instructionData === "string") {
    return instructionData;
  }

  if (instructionData.is_system && instructionData.note) {
    return instructionData.note;
  }

  return "";
}

/**
 * Combine saved instructions with current one-time instructions.
 */
export function combineInstructions(savedInstructions: string, currentInstructions: string): string {
  return [savedInstructions, currentInstructions].filter(Boolean).join("\n\n");
}
